export default __webpack_public_path__ + "static/media/Seahawks.831e7fa0.png";